module.exports = __webpack_public_path__ + "static/pic03-a5f6977391e29a896d3773075eec9bee.jpg";